import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from '@core/services/auth.service';

@Component({
  selector: 'app-verify-identity-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.scss'],
})
export class VerifyIdentityEmailConfirmationComponent {
  @Input({ required: true }) email: string = '';
  @Input({ required: true }) confirmedAt: string | undefined | null;

  protected sending = false;
  protected showUpdateEmail = false;

  constructor(
    private authService: AuthService,
    private toastr: ToastrService
  ) {}

  requestNewLink() {
    this.sending = true;

    this.authService.sendEmailConfirmation().subscribe({
      next: (res) => {
        if (!res || res.sendEmailConfirmation !== 'OK') {
          this.sending = false;
          this.toastr.error(
            'Failed to send confirmation email. Please try again later.',
            'Error'
          );
          return;
        }
        this.sending = false;
        this.toastr.success('New confirmation email sent!', 'Success');
      },
      error: () => {
        this.sending = false;
        this.toastr.error(
          'Failed to send confirmation email. Please try again later.',
          'Error'
        );
      },
    });
  }
}
